export default __webpack_public_path__ + "static/media/3686.e74961d0.png";